'use client';

import { MapPin } from 'lucide-react';

import { cn } from '@ui/lib/utils';

interface LocationFilterButtonProps {
  className?: string;
  locationLabel: string;
  onClick: () => void;
  chooseLocationText?: string;
  isActive?: boolean;
}

export function LocationFilterButton({
  className,
  locationLabel,
  onClick,
  chooseLocationText,
  isActive
}: LocationFilterButtonProps) {
  const autoSelected = chooseLocationText
    ? locationLabel !== chooseLocationText
    : locationLabel && locationLabel.trim() !== '';
  const isSelected = isActive ?? autoSelected;

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex items-center gap-2 px-3 py-2 border rounded-lg transition-colors cursor-pointer min-w-0',
        isSelected
          ? 'bg-primary-0 border-primary-200 hover:border-primary-300 [&_svg]:!text-primary-500'
          : 'bg-white border-neutral-200 hover:border-neutral-300',
        className
      )}
    >
      <MapPin className="w-5 h-5 flex-shrink-0" />
      <span
        className={cn(
          'text-sm font-normal whitespace-nowrap truncate min-w-0',
          isSelected
            ? 'text-primary-500'
            : locationLabel === chooseLocationText
              ? 'text-neutral-500'
              : 'text-neutral-900'
        )}
      >
        {locationLabel}
      </span>
      {/* {locationLabel !== chooseLocationText && (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="ml-2 h-4 w-4 text-neutral-500"
                >
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            )} */}
    </button>
  );
}
